import { activityHeaders, apiURL, csrfHeaders, processAuthError } from "../auth/session";

export class ApiError extends Error {
  constructor(public status: number, message: string) { super(message); }
}
export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers);
  for (const [key, value] of Object.entries(activityHeaders())) headers.set(key, value);
  const method = (init?.method ?? "GET").toUpperCase();
  if (method !== "GET" && method !== "HEAD") {
    for (const [key, value] of Object.entries(await csrfHeaders())) headers.set(key, value);
  }
  const res = await fetch(apiURL(path), { ...init, credentials: "same-origin", cache: "no-store", headers });
  await processAuthError(res);
  return res;
}
export async function apiGetJSON<T>(path: string): Promise<T> {
  const res = await apiFetch(path);
  if (!res.ok) {
    const body = await res.text().catch(() => "");
    throw new ApiError(res.status, `${path} ${res.status}: ${body}`);
  }
  return await res.json() as T;
}
